import { Injectable, inject } from '@angular/core';

import { Observable, map } from 'rxjs';

import { mapPlatformConfigResponse } from '@core/models/platform-config.mapper';
import { PlatformConfigResponse } from '@core/models/platform-config.response';
import { PlatformConfigState } from '@core/models/platform-config.state';
import { ApiService } from '@core/services/api.service';

import { PlatformConfigRepository } from './platform-config.repository';

@Injectable()
export class PlatformConfigHttpRepository implements PlatformConfigRepository {
  private readonly api = inject(ApiService);

  get(): Observable<PlatformConfigState> {
    return this.api.get<PlatformConfigResponse>('platform-config').pipe(map(mapPlatformConfigResponse));
  }
}
